const a11y = (i18n) => ({
  passwordBadgeChangeUser: () => i18n.gettext('Cambiar cuenta'),
});

module.exports = { a11y };
